import {GameColor} from '../GameColor'
import {showRulebookPopup} from '../ui_rulebook/UIRulebookPopupGlobal'
import {createDivIn, createExternalImgIn, createImgIn, setElementOnClick} from '../ui_utils/DomUtils'
import {UIChatPostText} from './UIChatPostText'
import {UIUtilsChat} from './UIUtilsChat'
import {ChatData} from '@colonist/shared-types'
import {UIUtilsEjsVariables} from '../UIUtilsEjsVariables'
import {uiGameManager} from '../EntryShared'
import {AudioManager, AudioType} from '@colonist/audio'

export class UIChatPostController {
    private readonly chatData: ChatData
    private readonly container: HTMLDivElement

    readonly post: HTMLDivElement

    private readonly textColorInGame: GameColor.Color = GameColor.Color.Gray0
    private readonly textColorInRoom: GameColor.Color = GameColor.Color.White

    private readonly isMessageSentInGame: boolean

    private readonly iconSize: number = 20

    constructor(container: HTMLDivElement, chatData: ChatData) {
        this.container = container
        this.chatData = chatData
        this.isMessageSentInGame = container.className.includes('game_chat')

        this.post = this.createPostDiv()

        if(chatData.profilePictureUrl) {
            const img = createExternalImgIn(this.post, chatData.profilePictureUrl, {key: 'strings:colonistCommon.utils.emptyString'})
            img.style.borderRadius = '50%'
            img.width = this.iconSize
            img.height = this.iconSize
        } else if(chatData.icon != undefined) {
            const img = createImgIn(this.post, chatData.icon)
            img.width = this.iconSize
            img.height = this.iconSize
        }

        const isLog = this.container.id == 'game-log-text'
        new UIChatPostText(this.post, this.chatData, this.textColorInGame, isLog)

        this.setEventHandlersForHelpLinks()
    }

    private createPostDiv(): HTMLDivElement {
        const post = createDivIn(this.container, 'message-post', '')
        if(!(UIUtilsEjsVariables.isUserOnMobileAppOrWeb && UIUtilsEjsVariables.shouldDisplayNewMobileGameUI)) post.style.color = this.isMessageSentInGame ? GameColor.getColor(this.textColorInGame) : GameColor.getColor(this.textColorInRoom)
        setElementOnClick(post, () => AudioManager.play(AudioType.Click))

        if(this.chatData.isCentered != true) return post
        post.classList.add('victory-text')
        post.style.color = UIUtilsChat.getTextColor('' + this.chatData.username, GameColor.getColor(this.textColorInGame))
        return post
    }

    private setEventHandlersForHelpLinks() {
        const linkElements = this.post.getElementsByTagName('a')

        for(const link of linkElements) {
            const url = new URL(link.href)

            if(url.hash == UIUtilsChat.OPEN_RULEBOOK_LINK_HASH) {
                setElementOnClick(link, () => {
                    uiGameManager.pauseController.pauseIfSinglePlayer()
                    showRulebookPopup()
                }, true, true)
                continue
            }
        }
    }
}
